import React, { Component } from 'react';

import IconBootstrap from '../../images/inline-svg/bootstrap.svg';
import IconSass from '../../images/inline-svg/sass.svg';
import IconReact from '../../images/inline-svg/react.svg';
import ReactIcon from '../../images/inline-svg/react-original.svg';
import IconAngularJs from '../../images/inline-svg/angular.svg';
import IconHTML5 from '../../images/inline-svg/html5.svg';
import IconCSS3 from '../../images/inline-svg/css3.svg';
import IconGatsby from '../../images/inline-svg/gatsby.svg';
import IconGit from '../../images/inline-svg/git.svg';
import IconNode from '../../images/inline-svg/node.svg';
import IconProtractor from '../../images/inline-svg/protractor.svg';
import IconHeroku from '../../images/inline-svg/heroku.svg';
import IconIonic from '../../images/inline-svg/ionic.svg';
import IconWordpress from '../../images/inline-svg/wordpress-original.svg';
import IconWebpack from '../../images/inline-svg/webpack.svg';
import IconWebstrom from '../../images/inline-svg/webstorm.svg';
import IconVue from '../../images/inline-svg/vuejs.svg';
import IconVsCode from '../../images/inline-svg/visualstudiocode.svg';
import IconSourceTree from '../../images/inline-svg/sourcetree.svg';
import IconMongo from '../../images/inline-svg/mongodb.svg';
import IconPhotoshop from '../../images/inline-svg/adobephotoshop.svg';
import IconLightroom from '../../images/inline-svg/adobelightroom.svg';
import IconExpress from '../../images/inline-svg/express.svg';
import IconJasmine from '../../images/inline-svg/jasmine.svg';
import IconJavascript from '../../images/inline-svg/javascript.svg';
import IconJQuery from '../../images/inline-svg/jquery.svg';
import IconMocha from '../../images/inline-svg/mocha.svg';
import IconYarn from '../../images/inline-svg/yarn.svg';

import IconBitbucket from '../../images/inline-svg/bitbucket.svg';
import IconCucumber from '../../images/inline-svg/cucumber.svg';
import IconGitlab from '../../images/inline-svg/gitlab.svg';
import IconGrunt from '../../images/inline-svg/grunt.svg';
import IconGulp from '../../images/inline-svg/gulp.svg';
import IconMeteor from '../../images/inline-svg/meteor.svg';
import IconNpm from '../../images/inline-svg/npm.svg';

const NoIcon = () => {
  return <div>No Icon</div>;
};

const TechIcon = ({ icon }) => {
  switch (icon) {
    case 'bootstrap.svg':
      return <IconBootstrap />;
      break;
    case 'sass.svg':
      return <IconSass />;
      break;
    case 'angular.svg':
      return <IconAngularJs />;
      break;
    case 'html5.svg':
      return <IconHTML5 />;
      break;
    case 'css3.svg':
      return <IconCSS3 />;
      break;
    case 'gatsby.svg':
      return <IconGatsby />;
      break;
    case 'git.svg':
      return <IconGit />;
      break;
    case 'node.svg':
      return <IconNode />;
      break;
    case 'protractor.svg':
      return <IconProtractor />;
      break;
    case 'heroku.svg':
      return <IconHeroku />;
      break;
    case 'ionic.svg':
      return <IconIonic />;
      break;
    case 'wordpress.svg':
      return <IconWordpress />;
      break;
    case 'webpack.svg':
      return <IconWebpack />;
      break;
    case 'vuejs.svg':
      return <IconVue />;
      break;
    case 'vscode.svg':
      return <IconVsCode />;
      break;
    case 'sourcetree.svg':
      return <IconSourceTree />;
      break;
    case 'mongo.svg':
      return <IconMongo />;
      break;
    case 'yarn.svg':
      return <IconYarn />;
      break;
    case 'mocha.svg':
      return <IconMocha />;
      break;
    case 'jquery.svg':
      return <IconJQuery />;
      break;
    case 'jasmine.svg':
      return <IconJasmine />;
      break;
    case 'express.svg':
      return <IconExpress />;
      break;
    case 'adobephotoshop.svg':
      return <IconPhotoshop />;
      break;
    case 'adobelightroom.svg':
      return <IconLightroom />;
      break;
    case 'adobelightroom.svg':
      return <IconLightroom />;
      break;
    case 'javascript.svg':
      return <IconJavascript />;
      break;
    case 'webstorm.svg':
      return <IconWebstrom />;
      break;
    case 'bitbucket.svg':
      return <IconBitbucket />;
      break;
    case 'cucumber.svg':
      return <IconCucumber />;
      break;
    case 'gitlab.svg':
      return <IconGitlab />;
      break;
    case 'grunt.svg':
      return <IconGrunt />;
      break;
    case 'gulp.svg':
      return <IconGulp />;
      break;
    case 'meteor.svg':
      return <IconMeteor />;
      break;
    case 'npm.svg':
      return <IconNpm />;
      break;
    default:
      return <NoIcon />;
      break;
  }
};
export default TechIcon;



// WEBPACK FOOTER //
// ./src/components/ImageSlider/TechIcon.js